import { FC } from 'react'

import useParametrizationConfigPurchase from '@hook/parametrization/use-config-purchase'

import HistoricModal, {
  HISTORIC_COLUMNS
} from '@component/Parameterization/Shared/HistoricModal'

import ParametroCompra from '@service/ParametroCompra'

const ModalHistoricPurchaseFerias: FC = () => {
  const { companieId } = useParametrizationConfigPurchase()
  return (
    <HistoricModal
      title="Histórico Férias de Compras"
      empresaId={companieId}
      // O endpoint de histórico de férias não recebe empresa: filtra no front
      // quando o registro traz empresaId
      fetcher={async empresaId => {
        const items: any[] =
          (await ParametroCompra.getFeriasCompradorHistorico()).data?.data ?? []
        return items.filter(
          item =>
            item?.empresaId == null || Number(item.empresaId) === empresaId
        )
      }}
      columns={[
        HISTORIC_COLUMNS.data,
        HISTORIC_COLUMNS.usuario,
        HISTORIC_COLUMNS.acao
      ]}
      emptyMessage="Nenhum histórico de férias encontrado."
    />
  )
}

export default ModalHistoricPurchaseFerias
